import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import { toast } from "react-toastify";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";
import {
  addCategory,
  deleteCategory,
  getCategories,
  updateCategory,
} from "../../../slices/2-category/thunk";
import MediaLibraryModal from "../../0-Media/MediaLibraryModal";

const CategoryTable = () => {
  const [modal_list, setmodal_list] = useState(false);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [name, setName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilter, setTypeFilter] = useState(" ");
  const [selectedId, setSelectedId] = useState(null);

  const [deleteModal, setDeleteModal] = useState(false);
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");
  const [mediaModal, setMediaModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(false);

  const { categories, loading, error, totalPages } = useSelector(
    (state) => state.Categories,
  );

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getCategories({ page, limit }));
  }, [dispatch, page]);

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(
      addCategory({
        name,
        description,
        image,
        isActive: true,
      }),
    )
      .unwrap()
      .then(() => {
        setmodal_list(false);
        resetForm();
        dispatch(getCategories({ page, limit }));
      })
      .catch((err) => toast.error(err?.message));
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteCategory(selectedId))
      .unwrap()
      .then(() => {
        setDeleteModal(false);
        dispatch(getCategories({ page, limit }));
      })
      .catch((err) => toast.error(err?.message));
  };

  const openEditModal = (item) => {
    setCurrentItem(item);
    setName(item.name);
    setDescription(item.description);
    setImage(item.image);
    setEditModal(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    dispatch(
      updateCategory({
        id: currentItem._id,
        data: {
          name,
          description,
          image,
        },
      }),
    )
      .unwrap()
      .then(() => {
        setEditModal(false);
        resetForm();
        dispatch(getCategories({ page, limit }));
      })
      .catch((err) => toast.error(err?.message));
  };

  const tog_list = () => {
    if (modal_list) resetForm();
    setmodal_list(!modal_list);
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setImage("");
    setCurrentItem(null);
    setSelectedId(null);
  };

  document.title = "Categories";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm?.length >= 3 || searchTerm?.length === 0) {
        dispatch(getCategories({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, page, searchTerm]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة الغرف" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  <div className="listjs-table" id="tagsList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="بحث..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>

                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1 rounded-3"
                            onClick={() => {
                              resetForm();
                              tog_list();
                            }}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            إضافة
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light text-center">
                          <tr>
                            <th>الأيقونة</th>
                            <th>اسم الغرفة</th>
                            <th>الوصف</th>
                            <th>عدد الأسئلة</th>
                            <th>الحالة</th>
                            <th>إجراءات</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all  text-center">
                          {categories && categories?.length > 0 ? (
                            categories?.map((item) => (
                              <tr key={item.id} className="fs-5">
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {item._id}
                                  </Link>
                                </td>
                                <td className="image">
                                  <img
                                    src={item.image}
                                    alt="image"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </td>
                                <td className="name">{item.name}</td>
                                <td className="desc">{item.description}</td>
                                <td className="questionsCount">
                                  {item.questionsCount}
                                </td>
                                <td>
                                  <span
                                    className={`badge rounded-pill ${
                                      !item.isBlocked
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {!item.isBlocked ? "نشط" : "محظور"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2 justify-content-center">
                                    <button
                                      className="btn btn-sm edit-item-btn"
                                      style={{
                                        padding: "0px",
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => openEditModal(item)}
                                    >
                                      <i
                                        className="ri-edit-line"
                                        style={{
                                          color: "gray",
                                          fontSize: "20px",
                                        }}
                                      ></i>
                                    </button>
                                    <button
                                      className="btn btn-sm remove-item-btn"
                                      style={{
                                        padding: "0px",
                                        background: "transparent",
                                        border: "none",
                                      }}
                                      onClick={() => handleDelete(item._id)}
                                    >
                                      <i
                                        className="ri-delete-bin-line"
                                        style={{
                                          color: "red",
                                          fontSize: "20px",
                                        }}
                                      ></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                لا يوجد غرف
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination */}
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6">
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(newPage) => {
                            setPage(newPage);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader toggle={tog_list}>إضافة غرفة جديدة</ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody>
            {/* اسم غرفة */}
            <div className="mb-3">
              <label className="form-label">اسم الغرفة</label>
              <input
                type="text"
                className="form-control"
                placeholder="مثال: الدوري الإنجليزي"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* الوصف */}
            <div className="mb-3">
              <label className="form-label">وصف غرفة (اختياري)</label>
              <textarea
                className="form-control"
                placeholder="وصف مختصر غرفة..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </div>

            {/* الأيقونات */}
            <div className="mb-3">
              <label className="form-label">الصورة</label>

              <div className="d-flex align-items-center gap-3">
                {image && (
                  <img
                    src={image}
                    alt="preview"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                )}

                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setMediaModal(true)}
                >
                  اختر صورة
                </button>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button className="btn btn-light" onClick={tog_list}>
              إلغاء
            </button>
            <button
              type="submit"
              className="btn btn-success"
              disabled={!name || !image || !description}
            >
              حفظ
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Edit Modal */}
      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered>
        <ModalHeader toggle={() => setEditModal(false)}>
          تعديل الغرفة
        </ModalHeader>

        <form onSubmit={handleEditSubmit}>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">اسم الغرفة</label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الوصف</label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">الصورة</label>

              <div className="d-flex align-items-center gap-3">
                {image && (
                  <img
                    src={image}
                    alt="preview"
                    style={{
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                )}

                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setMediaModal(true)}
                >
                  اختر صورة
                </button>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button
              className="btn btn-light"
              onClick={() => {
                setEditModal(false);
                resetForm();
              }}
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="btn btn-success"
              disabled={!name || !image}
            >
              حفظ
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Confirm Toggle Block Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الحذف
        </ModalHeader>

        <ModalBody>
          <div className="mt-2 text-center">
            <i className="ri-delete-bin-line display-3 text-danger"></i>

            <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
              <h4>هل أنت متأكد؟</h4>

              <p className="text-muted mx-4 mb-0">
                هل تريد حذف هذه الغرفة؟ لا يمكن التراجع عن هذا الإجراء
              </p>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="hstack gap-2 justify-content-center w-100">
            <Button color="light" onClick={() => setDeleteModal(false)}>
              إلغاء
            </Button>

            <Button color="danger" onClick={confirmDelete}>
              نعم، حذف
            </Button>
          </div>
        </ModalFooter>
      </Modal>

      <MediaLibraryModal
        isOpen={mediaModal}
        onClose={() => setMediaModal(false)}
        onSelect={(url) => {
          setImage(url);
          setMediaModal(false);
        }}
        multi={false}
        showTabs={{ images: true }}
      />
    </React.Fragment>
  );
};

export default CategoryTable;
